<template>
    <HeadNav></HeadNav>
    <slot></slot>
    <Toolbar/>
</template>

<script setup>
import HeadNav from './HeadNav.vue';
import Toolbar from './Toolbar.vue';

</script>

<style lang="scss" scoped>

</style>